<template>
  <div class="heuristic">
    <view-heu v-if="
      $store.state.auth.user.perm !== 'admin'
      || typeof $route.query.edit === 'undefined'
    " />
    <edit-heu v-else />
  </div>
</template>

<script>
import viewHeu from './view.vue';
import editHeu from './edit.vue';

export default {
  components: {
    viewHeu,
    editHeu,
  },
  async mounted() {
    const heuristics = await this.$store.dispatch('heuristics/find');
    console.log(heuristics);
    if (heuristics.length) this.$store.commit('heuristics/setCurrent', heuristics[0]._id);
  },
};
</script>
